import fetchData from './Fetch';
import { postData } from './Post';

// Récupérer les capacités d'une résidence (types de devices)
export const getResidenceCapabilities = async (residenceId) => {
  try {
    const response = await fetchData(`/api/residence/${residenceId}/device-capabilities`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Récupérer les seuils d'un device spécifique
export const getDeviceThresholds = async (devEui) => {
  try {
    const response = await fetchData(`/api/device/${devEui}/thresholds/details`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Mettre à jour les seuils d'un device
export const updateDeviceThresholds = async (devEui, thresholds) => {
  try {
    const response = await postData(`/api/device/${devEui}/thresholds/update`, thresholds);
    return response;
  } catch (error) {
    throw error;
  }
};

// Valeurs par défaut selon le type de température
export const getDefaultThresholds = (temperatureType) => {
  switch(temperatureType) {
    case 'ambiante':
      return { yellow: 25, red: 30 };
    case 'chambre_froide_positive':
      return { yellow: 6, red: 10 };
    case 'chambre_froide_negative':
      return { yellow: -15, red: -10 };
    default:
      return { yellow: 0, red: 5 };
  }
};
